import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IWebEditFlowAction } from '../../../../ts/ServerApi/types/actionNames';
import { newFlowForDatasource } from '../../../actions/spaces/NewFlowForDatasourceAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const NewFlowEntityAction: IEntityAction<IContentInfo<'datasource'>, IWebEditFlowAction> = {
  name: EntityActionNames.NewFlow,
  translateName: Messages.newFlow,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.flowDraftsEnabled && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IWebEditFlowAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.webEditFlow,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newFlowForDatasource(item);
    }
  }
};
